import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { Cidade } from '../cidade';
import { CidadeSubRegiao } from '../sub-regiao';

@Injectable({
    providedIn: 'root'
})
export class CidadeSearchesHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApi()}/cidade`;
    }

    /** Procura a cidade exterior */
    findExterior(): Observable<Cidade> {
        return this.customHttp.get<Cidade>(`${this.pathApi}/0/exterior`);
    }

    /** Pesquisa todas as sub-regiões da cidade informada */
    searchSubRegioes(idCidade: number, loadBairros: boolean): Observable<CidadeSubRegiao[]> {
        // Params
        let params = new HttpParams();
        // Carregar os bairros
        if (loadBairros != null && loadBairros !== undefined) {
            params = params.append('loadBairros', loadBairros.toString());
        }

        return this.customHttp.get<CidadeSubRegiao[]>(`${this.pathApi}/${idCidade}/subregiao`, {params});
    }
}
